export default "__VITE_ASSET__SoH7lurV__"